import { useState } from 'react'
import { CheckCircle } from 'lucide-react'
import { ExpenseCreateForm } from '../components/ExpenseCreateForm'
import { usePublicExpensesCategoriesQuery } from '../hooks/categories/usePublicExpensesCategoriesQuery'
import Loader from '@/components/Loader'
import { Button } from '@/components/ui/button'
import { usePublicChurchesQuery } from '@/features/churches/hooks/usePublicChurchesQuery'

export function PublicExpenseForm() {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const {
    data: churches,
    isLoading: churchesLoading,
    error: churchesError,
  } = usePublicChurchesQuery()

  const {
    data: categories,
    isLoading: categoriesLoading,
    error: categoriesError,
  } = usePublicExpensesCategoriesQuery()

  if (churchesLoading || categoriesLoading) {
    return <Loader />
  }

  if (churchesError || categoriesError) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            Failed to load form data
          </h2>
          <p className="text-gray-600 mb-4">
            There was an error loading the expense form. Please try again later.
          </p>
          <Button onClick={() => window.location.reload()}>Reload Page</Button>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-2xl border border-gray-300 rounded-lg p-6">
        {isSubmitted ? (
          <div className="text-center py-8">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Request Received!
            </h2>
            <p className="text-gray-600 mb-6">
              Your reimbursement request has been successfully submitted. You
              will receive an email confirmation shortly.
            </p>
            <Button
              onClick={() => setIsSubmitted(false)}
              className="px-4 py-2 text-white rounded-md transition-colors"
            >
              Submit Another Request
            </Button>
          </div>
        ) : (
          <ExpenseCreateForm
            publicChurches={churches}
            publicCategories={categories}
            onSuccess={() => setIsSubmitted(true)}
          />
        )}
      </div>
    </div>
  )
}
